import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["passwordShown", "toggleVisibility"];
import * as React from 'react';
import { InputField } from '../InputField';
import { EyeCrossedIcon, EyeIcon } from './icons';
import * as styles from './PasswordField.css';
export var PasswordField = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var passwordShown = _ref.passwordShown,
    toggleVisibility = _ref.toggleVisibility,
    props = _objectWithoutProperties(_ref, _excluded);
  var inputType = React.useMemo(function () {
    return passwordShown ? 'text' : 'password';
  }, [passwordShown]);
  var icon = React.useMemo(function () {
    return passwordShown ? /*#__PURE__*/React.createElement(EyeCrossedIcon, null) : /*#__PURE__*/React.createElement(EyeIcon, null);
  }, [passwordShown]);
  return /*#__PURE__*/React.createElement(InputField, _extends({
    "data-name": "PasswordField"
  }, props, {
    ref: ref,
    type: inputType,
    addon: /*#__PURE__*/React.createElement("button", {
      className: styles['addon'],
      disabled: props.disabled,
      type: "button",
      onClick: toggleVisibility
    }, icon)
  }));
});
PasswordField.displayName = 'PasswordField';